import {Image, Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import {ConferenceUser} from 'models/ConferenceUser';
import strings from 'translations';
import {getFirstLettersFromUsername} from 'helpers/getFirstLettersFromUsername';

export interface ParticipantItemProps {
  user: ConferenceUser;
}

const ParticipantItem = (props: ParticipantItemProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const Username = (
    <Text style={styles.name}>
      {props.user.username +
        (props.user.isLocal
          ? ` (${strings.conferenceScreen.participants.me})`
          : '')}
    </Text>
  );

  const UserImage = (
    <View style={styles.userImageContainer}>
      <Text style={styles.userImageText}>
        {getFirstLettersFromUsername(props.user.username)}
      </Text>
    </View>
  );

  const AudioDisabled = (
    <View style={styles.disabledContainer}>
      <Image
        source={theme.images.participantsMicroOff}
        style={styles.disabledImage}
      />
    </View>
  );

  const VideoDisabled = (
    <View style={styles.disabledContainer}>
      <Image
        source={theme.images.participantsVideoOff}
        style={styles.disabledImage}
      />
    </View>
  );

  return (
    <View style={styles.container}>
      {UserImage}
      {Username}
      {!props.user.stream.isAudioEnabled && AudioDisabled}
      {!props.user.stream.isAudioEnabled &&
        !props.user.stream.isVideoEnabled && <View style={styles.spacer} />}
      {!props.user.stream.isVideoEnabled && VideoDisabled}
    </View>
  );
};

export default ParticipantItem;
